import React, { useContext } from "react";

import classNames from "classnames";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import styled from "styled-components";

import ComponentContext from "../../../contexts/ComponentContext";
import { useStores } from "../../../contexts/StoreContext";
import VacancyImage from "./VacancyImage";

const StyledVacancy = styled.a`
  background-color: ${({ $isVacancySelected, $backgroundColor }) =>
    $isVacancySelected && ($backgroundColor || "#fff")};
  text-decoration: none !important;
  color: ${({ theme, $selectedVacancyColor, $isVacancySelected }) =>
    $isVacancySelected
      ? $selectedVacancyColor || theme.textColor
      : "#000"} !important;
`;

function VacancyListItem(props) {
  const { isSelected, onClick, thumbnailUrl, vacancy } = props;
  const { trackingStore } = useStores();
  const { refererQuery, refererQueryString } = trackingStore;
  const { additionalConfig, cityInTitle, selectedVacancyColor } =
    useContext(ComponentContext);

  const imageUrl = vacancy?.company?.logoUrlFull || thumbnailUrl;

  let titleText = vacancy.jobTitle;

  if (vacancy?.location?.city && cityInTitle) {
    titleText = `${vacancy?.location?.city} - ${vacancy.jobTitle}`;
  }

  const styledVacancyClassName = classNames("d-flex px-3 py-3", {
    vacancySelected: isSelected,
  });

  const shouldAppendReferer = refererQuery?.utm_source !== "Direct";

  const vacancyHref = [
    `/job/${vacancy.id}`,
    shouldAppendReferer ? refererQueryString : null,
  ]
    .filter(Boolean)
    .join("?");

  return (
    <StyledVacancy
      $backgroundColor={additionalConfig?.selectedVacancy?.backgroundColor}
      className={styledVacancyClassName}
      href={vacancyHref}
      $isVacancySelected={isSelected}
      onClick={(e) => onClick(vacancy.id, e)}
      $selectedVacancyColor={selectedVacancyColor}
    >
      <VacancyImage imageUrl={imageUrl} />

      <div>
        <p className="fw-bold text-uppercase vacancy-item-heading mb-0">
          {titleText}
        </p>
        <p className="text-muted">{vacancy?.company?.name}</p>
        <span className="vacancy-description vacancy-item-description">
          {vacancy.location?.city}
          <br />
          {vacancy.remuneration?.description}
        </span>
      </div>
    </StyledVacancy>
  );
}

export default observer(VacancyListItem);

VacancyListItem.propTypes = {
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
  thumbnailUrl: PropTypes.string,
  vacancy: PropTypes.shape({
    id: PropTypes.string,
    jobTitle: PropTypes.string,
    location: PropTypes.shape({
      city: PropTypes.string,
    }),
    remuneration: PropTypes.shape({
      description: PropTypes.string,
    }),
  }),
};

VacancyListItem.defaultProps = {
  isSelected: false,
  onClick: () => {},
  thumbnailUrl: null,
  vacancy: null,
};
